/* 
Pantalla informativa de email confirmado.
 */

import React from "react";

//#region CSS
import { makeStyles } from "@material-ui/core/styles";
import Fade from "@material-ui/core/Fade";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
const useStyles = makeStyles(theme => ({
  root: {
    marginTop: "10px",
    display: "flex"
  },
  border: {
    boxShadow: "0px 0px 3px 1px #9abf3a",
    paddingTop: "40px",
    paddingBottom: "40px",
    marginTop: "60px",
    marginBottom: "50px"
  },
  labelBig: {
    fontSize: "1.25rem",
    align: "justify"
  }
}));
//#endregion

function EmailConfirmed({ history, match }) {
  const classes = useStyles();

  const { mail } = match.params;

  const onClickBackLogin = () => {
    history.push("/");
  };

  return (
    <div className={classes.root}>
      <Grid container spacing={2} justify="center" alignItems="center">
        <Fade in={true} timeout={1000}>
          <Grid item xs={11} md={6} lg={4} xl={3}>
            <Box textAlign="center">
              <img
                alt="Logo"
                src={`${process.env.PUBLIC_URL}/assets/img/logo_V2.png`}
                title="Logo"
                height="100px"
                className="mt-5"
              />
            </Box>
            <Grid
              item
              xs={12}
              className={`${classes.border} pt-5 pb-5 pl-3 pr-3`}
            >
              <Box textAlign="center">
                <Typography color="secondary" variant="h5" data-lang="email_modified_title">
                  Email modificado
                </Typography>
              </Box>
              <Box textAlign="center">
                <label align="justify" className="mb-0 mt-4" data-lang-html="email_modified_message" data-lang-vars={JSON.stringify({mail: mail})}>
                  Revisa tu nuevo email en {mail}, para confirmarlo.
                </label>
              </Box>
              <div style={{ textAlign: "center" }}>
                <Button
                  type="button"
                  variant="contained"
                  color="primary"
                  fullWidth
                  style={{ width: "80%" }}
                  className={"mt-4"}
                  onClick={onClickBackLogin}
                  data-lang="register_go_to_club"
                >
                  Entrar al Club
                </Button>
              </div>
            </Grid>
          </Grid>
        </Fade>
      </Grid>
    </div>
  );
}

export default EmailConfirmed;
